import React, {Component} from 'react';
import glamorous from 'glamorous';
import SimpleButton from '../../../../shared/library/buttons/base/simple';
import PropTypes from 'prop-types';
import {FOCUS_BLUE, ASH} from '../../../../shared/style/colors';
import {BASE_TEXT} from '../../../../shared/style/typography';
import SocialGraphic from '../../../../shared/library/icons/social-graphic.png';
import Heading from '../../../../shared/library/typography/heading';
import {
  STACKUPS_QUESTION_CLICK_CTA
  // STACKUPS_QUESTION_DWELL,
  // STACKUPS_QUESTION_VIEWED
} from '../../constants/analytics';
import {withSendAnalyticsEvent} from '../../../../shared/enhancers/analytics-enhancer';
// import DwellTracker from '../../../../shared/utils/dwell-tracker';
import LazyLoadImage from '../../../../shared/utils/lazy-loading-images';
import {ID} from '../../../../shared/utils/graphql';
import {PHONE} from '../../../../shared/style/breakpoints';

const Question = glamorous.div(
  {
    ...BASE_TEXT,
    maxWidth: 1170,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: '5px 20px',
    [PHONE]: {
      padding: 10,
      flexWrap: 'wrap',
      margin: 0,
      justifyContent: 'center',
      border: 0
    }
  },
  ({hasBorder}) => ({
    border: hasBorder ? `1px solid ${ASH}` : 'none',
    padding: hasBorder ? '10px 20px' : '0'
  })
);

const QuestionInner = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  [PHONE]: {
    width: 'auto'
  }
});

const Image = glamorous.img({
  width: 100,
  height: 'auto',
  marginRight: 25
});
const StyledHeading = glamorous(Heading)({
  fontSize: 15,
  lineHeight: 32 / 22
});

const CallOut = glamorous.span({
  color: FOCUS_BLUE,
  display: 'block',
  fontSize: 12,
  fontWeight: 'normal'
});

const StyledSimpleButton = glamorous(SimpleButton)({
  height: 34,
  fontSize: 13,
  [PHONE]: {
    marginTop: 10
  }
});

export class QuestionPanelLarge extends Component {
  static propTypes = {
    sendAnalyticsEvent: PropTypes.func,
    userId: ID,
    stackupName: PropTypes.string,
    stackupSlug: PropTypes.string,
    panelPosition: PropTypes.string,
    hasBorder: PropTypes.bool,
    onClick: PropTypes.func
  };

  state = {
    showModal: false,
    showLogin: false,
    signinAction: null
  };

  handleDismiss = () => {
    this.setState({showModal: false});
    if (!this.props.userId) {
      this.setState({showLogin: true});
    }
  };

  // componentDidMount() {
  //   const {sendAnalyticsEvent, userId, stackupName, stackupSlug, panelPosition} = this.props;
  //   new DwellTracker(this._el, time =>
  //     sendAnalyticsEvent(STACKUPS_QUESTION_DWELL, {
  //       time,
  //       userId,
  //       stackupName,
  //       stackupSlug,
  //       panelPosition
  //     })
  //   );
  //   new DwellTracker(
  //     this._el,
  //     () => {
  //       sendAnalyticsEvent(STACKUPS_QUESTION_VIEWED, {
  //         userId,
  //         stackupName,
  //         stackupSlug,
  //         panelPosition
  //       });
  //     },
  //     1
  //   );
  // }

  handleOnClick = () => {
    const {
      sendAnalyticsEvent,
      userId,
      stackupName,
      stackupSlug,
      panelPosition,
      onClick
    } = this.props;
    onClick();
    sendAnalyticsEvent(STACKUPS_QUESTION_CLICK_CTA, {
      userId,
      stackupName,
      stackupSlug,
      panelPosition
    });
  };

  render() {
    const {hasBorder = true} = this.props;
    return (
      <React.Fragment>
        <Question
          data-testid="getAdvice"
          innerRef={el => (this._el = el)}
          onClick={this.handleOnClick}
          hasBorder={hasBorder}
        >
          <QuestionInner>
            <LazyLoadImage>
              <Image src={SocialGraphic} alt="Get Advice Icon" />
            </LazyLoadImage>
            <StyledHeading>
              Need advice about which tool to choose?
              <CallOut>Ask the StackShare community!</CallOut>
            </StyledHeading>
          </QuestionInner>
          <StyledSimpleButton width={270}>Get Advice</StyledSimpleButton>
        </Question>
      </React.Fragment>
    );
  }
}

export default withSendAnalyticsEvent(QuestionPanelLarge);
